const STRINGS = {
  DATES: {
    DAY_MONTH_YEAR: "DD/MM/YYYY",
    DAY_MONTH: "DD/MM",
    HOUR_MINUTE: "hh:mm"
  },
  COLORS: {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    SUCCESS: "success",
    DANGER: "danger",
    INFO: "info",
    WARNING: "warning",
    DARK: "dark",
    LIGHT_PRIMARY: "light-primary",
    LIGHT_SECONDARY: "light-secondary",
    LIGHT_INFO: "light-info",
    LIGHT_SUCCESS: "light-success",
    LIGHT_WARNING: "light-warning",
    LIGHT_DANGER: "light-danger",
    LIGHT_DARK: "light-dark"
  },
  TEXTS: {
    EMPTY_TEXT: "---"
  },
};

const RH_SEPARATOR = '.';
const API_RH_SEPARATOR = '.'

const inscriptionFormCountries = {
  france: "france",
  switzerland: "switzerland"
}

const inscriptionFormContentByCountry = {
  france: {
    close_1: "close_1_fr",
    close_2: "close_2_fr",
    close_3: "close_3_fr",
    close_4: "close_4_fr",
    close_5: "close_5_fr",
    paragraph_4: "paragraph_4_fr",
    paragraph_5: "paragraph_5_fr",
    npa_locality: "npa_locality_fr",
    work_permit: "work_permit_fr",
    diploma_qualification: "diploma_qualification_fr"
  },
  switzerland: {
    close_1: "close_1",
    close_2: "close_2",
    close_3: "close_3",
    close_4: "close_4",
    close_5: "close_5",
    paragraph_4: "paragraph_4",
    paragraph_5: "paragraph_5",
    npa_locality: "npa_locality",
    work_permit: "work_permit",
    diploma_qualification: "diploma_qualification"
  }
}

const switzerlandIsoCode = "CH"
const noWorkPermissionNeed = "PERMIS_TRAVAIL_AUCUNE_AUTORISATION"

export { STRINGS, RH_SEPARATOR, API_RH_SEPARATOR, inscriptionFormCountries, inscriptionFormContentByCountry, switzerlandIsoCode, noWorkPermissionNeed };